import store, { MutationName } from '@/store'

export const showToast = (message: string) => {
  store.commit(MutationName.SET_TOAST, {
    message,
    show: true,
  })
}

export const makeToastFuncAsync = (message: string) => async () => {
  store.commit(MutationName.SET_TOAST, {
    message,
    show: true,
  })
}
